<template>
  <CHeader with-subheader>
    <div class="top-nav-wrapper">
      <CToggler in-header class="ml-2 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
      <CToggler in-header class="ml-1 pl-0 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
      <CHeaderBrand class="mx-auto d-lg-none" src="/static/img/brand/coreui-signet-white.svg" width="190" height="46" />
      <CHeaderNav class="d-md-down-none mr-auto" ref="navHeader">
      </CHeaderNav>
      
      <CHeaderNav v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_MANAGEMENT_DEVICE')" >
        <TheHeaderChooseLocation v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_MANAGEMENT_DEVICE')" />
      </CHeaderNav>
      
      <CHeaderNav>

          <TheHeaderDropdownNotif />
          <TheHeaderDropdownAccnt />
        <!--        <CHeaderNavItem class="px-3">-->
        <!--            <button in-header class="c-header-nav-btn"-->
        <!--              @click="$store.commit('toggle', 'asideShow')">-->
        <!--              <CIcon size="lg" name="cil-applications-settings" class="mr-2"/>-->
        <!--            </button>-->
        <!--          </CHeaderNavItem>-->
      </CHeaderNav>
    </div>
    <div class="sub-header-wrapper">
      <div>
        <div class="title-page">
          <h4 style="margin-bottom:0;">{{ $route.name }}</h4>
        </div>
        <CSubheader>
          <CBreadcrumbRouter class="border-0 mt-0 mb-0" />
        </CSubheader>
      </div>
    </div>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif';
import TheHeaderChooseLocation from './TheHeaderChooseLocation';

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderChooseLocation
  },
  created() {

  },
  mounted() {
  },
  data() {
    return {};
  }
};
</script>
